function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("circle", {
  fill: "#6DD3A9",
  cx: 8,
  cy: 8,
  r: 8
}), React.createElement("path", {
  d: "M6.72 10.28a.75.75 0 001.06 0l3-3a.75.75 0 10-1.06-1.06L7.259 8.698 6.28 7.72a.75.75 0 00-1.06 1.06l1.5 1.5z",
  fill: "#FFF"
}));

const SvgGreenCheck = ({
  svgRef,
  ...props
}) => React.createElement("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  ref: svgRef
}, props), _ref);

const ForwardRef = React.forwardRef((props, ref) => React.createElement(SvgGreenCheck, _extends({
  svgRef: ref
}, props)));
export default ForwardRef;